.content {
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    /* If changing, update the min width of the lead page (lead-page.module.css)
    and header (header.module.css) */
    gap: 8px;
    position: relative;
    min-width: 800px;
}

.m1-half-width-section {
    width: calc(50% - 4px); /* Need to subtract half of the gap between sections */
}
